import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { MaxPrice, RegularBenefitVariant } from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuiteMaxPrice(intl: IntlShape) {
  return create(({ value, type }: MaxPrice) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.MaxPrice, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })
    })
  })
}
